import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import DebitCard from './components/DebitCard';

function DebitCardsList({
  debitCards,
  loadingAccounts,
  usedAt,
  createBankingCardForInstantFunding,
  isDailyTransferLimitExceeded
}) {
  return (
    <Stack direction="column">
      {(debitCards || []).map(
        (
          {
            cardHolderFirstName,
            cardHolderLastName,
            cardLastFourDigits,
            cardType,
            isCardValidForTransfers,
            uuid,
            isCardExpired
          },
          idx
        ) => (
          <DebitCard
            accountType={cardType}
            cardHolderFirstName={cardHolderFirstName}
            cardHolderLastName={cardHolderLastName}
            cardLastFourDigits={cardLastFourDigits}
            createBankingCardForInstantFunding={createBankingCardForInstantFunding}
            id={uuid}
            isCardExpired={isCardExpired}
            isCardValidForTransfers={isCardValidForTransfers}
            isDailyTransferLimitExceeded={isDailyTransferLimitExceeded}
            isLatest={debitCards.length === idx + 1}
            key={uuid}
            loadingAccounts={loadingAccounts}
            usedAt={usedAt}
          />
        )
      )}
    </Stack>
  );
}

DebitCardsList.propTypes = {
  debitCards: PropTypes.arrayOf(
    PropTypes.shape({
      cardHolderFirstName: PropTypes.string.isRequired,
      cardHolderLastName: PropTypes.string.isRequired,
      cardLastFourDigits: PropTypes.string.isRequired,
      cardType: PropTypes.string.isRequired,
      uuid: PropTypes.string.isRequired,
      isCardExpired: PropTypes.bool
    })
  ).isRequired,
  loadingAccounts: PropTypes.bool,
  usedAt: PropTypes.string,
  createBankingCardForInstantFunding: PropTypes.func,
  isDailyTransferLimitExceeded: PropTypes.bool
};

export default DebitCardsList;
